import { z } from 'zod';

export const loginSchema = z.object({
  email:     z.string().email(),
  password:  z.string().min(8),
  sessionId: z.string().optional(),
});

export const magentoExchangeSchema = z.object({
  magentoToken: z.string().min(1),
  storeId:      z.string().optional(),
  sessionId:    z.string().optional(),
});

export type LoginInput            = z.infer<typeof loginSchema>;
export type MagentoExchangeInput  = z.infer<typeof magentoExchangeSchema>;
